import { Settings } from "../../../Settings";
import Totals from "../../crew/Totals";
import GoldUpgrade from "./GoldUpgrade";
import UpgradeCostCalculator from "../classic/UpgradeCostCalculator";
import BigNumValue from "../../value/BigNumValue";
import BigNum from "../../math/BigNum";
import NumberFormatter from "../../../util/NumberFormatter";

export default class OreBonusGoldUpgrade extends GoldUpgrade {
    /**
     * @param {string} id
     * @param {string} title
     * @param {string} iconFileName
     * @param {UpgradeCostCalculator} upgradeCostCalculator 
     * @param {number} maxCount
     * @param {Totals} totals
     * @param {BigNumValue} oreBonusValue
     */
    constructor(id, title, iconFileName, upgradeCostCalculator, maxCount, totals, oreBonusValue) {
        super(id, title, iconFileName, upgradeCostCalculator, maxCount, totals);

        /**
         * @constant
         * @type {BigNumValue}
         */
        this.oreBonusValue = oreBonusValue;
        
        /**
         * @constant
         * @type {BigNum}
         */
        this.displayedMultiplier = new BigNum(-10);

        /**
         * @type {string}
         */
        this.description = null;
    }

    /**
     * @override
     * @returns {string}
     */
    getDescription() {

        const oreBonus = this.oreBonusValue.getValue();
        if (!this.description || !oreBonus.equals(this.displayedMultiplier)) {
            this.displayedMultiplier.copy(oreBonus);
            this.description = 'x' + NumberFormatter.formatBigNum(oreBonus);
        }

        return this.description;
    }

    /**
     * Invoked by the base class to let the sub-class know that a purchase has been made.
     * @override
     * @param {number} currentCount This is the before value.
     * @param {number} purchaseCount 
     */
    onUpgradePurchased(currentCount, purchaseCount) {
        super.onUpgradePurchased(currentCount, purchaseCount);

        /**
         * @type {BigNum}
         */
        const oreBonus = this.oreBonusValue.getValue();

        if (oreBonus.equalsZero()) {
            oreBonus.setValue(1);
        }

        const bonus = new BigNum(Settings.gold.oreBonusMultiplierPerUpgrade);

        for (let i = 0; i < purchaseCount; i++) {
            oreBonus.mul(bonus);
        }
    }

}